import { Box, List, ListItem, Typography } from "@mui/material"

export const Rules = () => {
    return (
        <Box sx={{ pb: 3 }}>
            <Typography
                variant="h3"
                align="center"
                sx={{
                    mt: 3,
                    fontWeight: 200,
                    fontSize: {
                        xs: '2.5rem',
                        sm: '3rem',
                    }
                }}>
                Rules
            </Typography>

            <Typography
                variant="h4"
                align="center"
                sx={{
                    mt: 2,
                    fontWeight: 200,
                    fontSize: {
                        xs: '1.5rem',
                        sm: '2rem',
                    }
                }}>
                General Rules
            </Typography>
            <List sx={{ px: { xs: 3, sm: 6 }, listStyleType: 'disc' }}>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Membership:</Typography> A member is defined as a paid member in good standing, including their spouse or significant other as referenced in <em>Article II, Section 90</em> of the 80 Conservation Club Bylaws Rev 2026.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Guests:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Guests (children, dependents, relatives, friends) are not members and may only access club property when accompanied by their responsible member.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Members are responsible for their guests' actions and must ensure they follow all club rules.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Groups including more than 10 non-members require prior notification to a Board of Directors member.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Property Maintenance:</Typography> Members must leave all areas used in as good or better condition than found. Remove all trash, as the club has no trash service. <em>Executive Board approval is required to add/bring/leave any item for general club use onto the property.</em>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Vehicles:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>No motorcycles, ATVs, side-by-sides, or UTVs are allowed on club grounds beyond designated roadside.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>
                            Golf carts and maintenance gators are permitted, operated by individuals 21+
                            years old, following Vanderburgh County ordinances. Operators must provide
                            proof of insurance, and vehicles require club approval, inspection, and an annual
                            $100 fee.
                            <List sx={{ listStyleType: 'square', pl: 2, mt: 1 }}>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>
                                    Permitted use areas: clubhouse, campground, swim beach, fishing dock.
                                </ListItem>
                            </List>
                        </ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>
                            No vehicles (cars, trucks, motorcycles, ATVs, etc.) are allowed on the
                            dam or primitive campground; golf carts and gators are allowed.
                        </ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Structures:</Typography>&nbsp;
                    No privately owned permanent buildings or sheds are allowed on club
                    grounds.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Membership Verification:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>
                            All members may and are expected to request identification from unknown individuals
                            on club property. (Be nice and introduce yourself...get to know other members in our club).
                        </ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>
                            Verify membership via the club website’s membership list or by contacting the
                            Secretary.
                        </ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Conduct</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>
                            Illegal drugs, excessive alcohol use, or profane language are prohibited.
                            Violators will be asked to leave, and membership may be suspended.
                        </ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Fires:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Adhere to local and state open burning laws.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Campfires or cooking fires are permitted only in enclosed fire rings at campsites or in the fire pit east of the clubhouse in the picnic area.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Never leave fires unattended; extinguish completely before leaving.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Trash:</Typography> Take all trash home, including cans and glass containers, as the club has no trash service.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Fireworks:</Typography> Confine fireworks to the rifle range. (Only during Board approved times/dates)
                </ListItem>
            </List>

            <Typography
                variant="h4"
                align="center"
                sx={{
                    mt: 4,
                    fontWeight: 200,
                    fontSize: {
                        xs: '1.5rem',
                        sm: '2rem',
                    }
                }}>
                Clubhouse & Picnic Area Rules
            </Typography>
            <List sx={{ px: { xs: 3, sm: 6 }, listStyleType: 'disc' }}>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Furniture:</Typography>
                    Do not remove furniture from the clubhouse or screened-in porch or picnic tables from the shelterhouse.&nbsp;
                    <Typography component='span' sx={{ fontWeight: 600 }}>
                        Executive Board approval is required to add/bring/leave any furniture, appliance, or other item into the
                        clubhouse.
                    </Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Cooking:</Typography> Cooking is permitted only in the kitchen using the electric stove or microwave.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Parking:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>When established, park only in designated parking areas or by a campsite.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Keep the driveway around the clubhouse clear of vehicles.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>No parking on the road, between the clubhouse and swimming area, in the picnic area, or on the shooting range.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Pets:</Typography> No dogs or pets are allowed in the clubhouse or on the screened porch. Dogs must be on a leash around the Clubhouse and Picnic Area.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Swimmers:</Typography> Swimmers with wet clothing or feet must use the back door and avoid the clubhouse and kitchen. Use showers or bathrooms for changing.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Usage:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>The clubhouse cannot be used as living quarters.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>No camping around the clubhouse or shelter/picnic area.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Reservations:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Reserve the clubhouse/shelterhouse for events via the club website's reservation feature on a first-come, first-serve basis. Clubhouse/shelterhouse reservation <em>does not</em> preclude any other member from accessing and utilizing the remaining property or amenities.</ListItem>
                    </List>
                </ListItem>
            </List>

            <Typography
                variant="h4"
                align="center"
                sx={{
                    mt: 4,
                    fontWeight: 200,
                    fontSize: {
                        xs: '1.5rem',
                        sm: '2rem',
                    }
                }}>
                Lake Use Rules
            </Typography>
            <List sx={{ px: { xs: 3, sm: 6 }, listStyleType: 'disc' }}>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Safety:</Typography> No lifeguard is on duty. Children under 14 must be supervised by an adult (18+ years) while swimming or boating.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Swimming:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Swim only within the marked swimming area.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>No swimming from boats.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}><Typography component="span" sx={{ fontWeight: 600, fontStyle: 'italic' }}>No glass containers</Typography> on the beach or in the swimming area!</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Boating:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Keep boats/kayaks/paddleboards out of the marked swimming area.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Fishermen have priority for boat use. Do not park by the lake.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Return boats/kayaks/paddle boards to the dock area, set aside down.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>No gasoline motors are allowed on the lake.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Fishing:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>When established, fish bag and size limits are posted in the clubhouse and by the lake. Limits are in place to ensure all have an enjoyable fishing experience.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>No fishing is allowed in the swimming area, including off of the swimming dock.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Take all trash/empty bait containers/discard line home for disposal.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Do not dump unused minnows in the lake.</ListItem>
                    </List>
                </ListItem>
            </List>

            <Typography
                variant="h4"
                align="center"
                sx={{
                    mt: 4,
                    fontWeight: 200,
                    fontSize: {
                        xs: '1.5rem',
                        sm: '2rem',
                    }
                }}>
                Camping Area Rules
            </Typography>
            <List sx={{ px: { xs: 3, sm: 6 }, listStyleType: 'disc' }}>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Trash:</Typography> Take all trash, including cans and glass, home with you. Do not leave trash at the club.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Pets:</Typography> All dogs must be kept on a leash at all times when outside of your campsites. Be courteous of others and pick up after your pet.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Tables:</Typography> Do not move tables from the picnic area to campsites. Bring your own tables for camping.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Camping:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Camping is permitted only in designated campsites using standard camping equipment (e.g., tents, campers, sleeping bags, portable grills).</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Sites #1 and #2 are first come, first-served sites for a <Typography component="span" sx={{ fontWeight: 600 }}>$20</Typography> donation/night. No more then two vehicles/units per site.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Campsites are not for storage of non-camping items (e.g., construction materials, appliances, bass boats or other non-camping related items). Canoes and kayaks are permitted.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>No permanent buildings, sheds, or tiny houses are allowed.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Air conditioner use is prohibited.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Electric vs. non-electric site fees to be determined by the Board.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Campsite Maintenance:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Members are responsible for maintaining their campsite, including mowing grass and keeping fire ring defined and enclosed.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Unkempt sites or unused campers will be addressed by the Board:
                            <List sx={{ listStyleType: 'square', pl: 2, mt: 0.5 }}>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Members will be notified of violations and given two weeks to correct issues. Old campers stored on site and not in use must be removed.</ListItem>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Non-compliant campers or equipment will be removed at the owner's expense and the site will be returned to the available site list.</ListItem>
                            </List>
                        </ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Quiet Hours:</Typography> To maintain a peaceful environment, avoid excessive noise, bright lights, or disruptive activities from 10:00 PM to 8:00 AM.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Generators:</Typography> Generator use is permitted but must not disturb neighboring campsites. Limit use hours to 8:00 AM-8:00 PM.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Note on Camper Storage:</Typography> The Board may consider a policy allowing year-round camper storage with an annual fee or maintenance agreement, pending further discussion.
                </ListItem>
            </List>

            <Typography
                variant="h4"
                align="center"
                sx={{
                    mt: 4,
                    fontWeight: 200,
                    fontSize: {
                        xs: '1.5rem',
                        sm: '2rem',
                    }
                }}>
                Rifle/Archery Range Rules
            </Typography>
            <List sx={{ px: { xs: 3, sm: 6 }, listStyleType: 'disc' }}>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Check-in:</Typography> All members and guests are to sign and date the Range List located on the Check Station prior to using the range signifying they have read and understood the Range Safety requirements. This is to be done prior to each usage.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Range Use Safety Rules:</Typography> Eye and ear protection are mandatory for all shooters and spectators whenever the range is hot. Members and guests using the range will always follow the four universal firearms safety rules:
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Treat every firearm as if it is loaded.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Never point a firearm at anything you do not intend to destroy.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Keep your finger off the trigger until you have made a conscious decision to fire.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Always know your target and what is beyond it.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Hours of Operation:</Typography> Range hours are from <strong>8:00am-8:00pm</strong> daily. Range hours purpose is to limit noise pollution for other club members camping or otherwise enjoying the club.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Liability & Responsibility:</Typography> <Typography component="span" sx={{ fontWeight: 600 }}>Shoot at your own risk!</Typography> Each shooter is solely responsible for each round they fire. Members are responsible for the actions of their guests and must supervise them at all times. Members must ensure their guests have read and understood these rules prior to shooting.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Annual Review:</Typography> Range rules shall be reviewed with members at least once per year. Members will be notified of any substantive changes.
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Alcohol & Drugs:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>No alcohol or drugs are allowed on the range.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Members and guest <strong>must not be under the influence</strong> of alcohol of drugs while on the firing line or while handling firearms.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Any person suspected of being impaired will be removed from the range and may face diciplinary action.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Range Status, Firing Line & Cease-Fire:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>A <strong>Firing Line must be established and respected</strong>. The firing line must be a common, clearly understood line that applies equally to all shooters and to the archery area (when the archery is in use).</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}><strong>No one may travel in front of the firing line</strong> unless the line has been declared safe by all shooters on the line and any archery shooters have been coordinated with and declared safe.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}><strong>Anyone may call an immediate CEASE FIRE</strong> if they observe an unsafe condition. When "Cease Fire!" is called:
                            <List sx={{ listStyleType: 'square', pl: 2, mt: 0.5 }}>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Stop shooting immediately.</ListItem>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Keep the muzzle pointed downrange.</ListItem>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Unload or make firearm safe.</ListItem>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Await further instructions before handling firearm or moving forward.</ListItem>
                            </List>
                        </ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Safe Condition (When Not Firing):</Typography> When firearms are not being fired they must be holstered or placed in a safe <strong>condition</strong>, defined as:
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Action open (where applicable), AND</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Magazine removed, AND</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Chamber visually and physically verified empty, AND</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Safety engaged if the firearm has an external safety.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Ammunition & Prohibited Rounds:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}><strong>Prohibited:</strong> All Browning .50-caliber-based rounds and similar extreme rounds, including but not limited to: <strong>.50 BMG, .416 Barrett, .408 CheyTac, .357 CheyTac</strong></ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}><strong>Prohibited:</strong> Use of <strong>Tannerite</strong>, explosives, or any mixtures intended to create reactive targets.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Other ammunitions restrictions may be posted for safety reasons by the Range Committee.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Targets & Target Placement:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Shot Placement: Set targets so all rounds impact the berm.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Approved target materials: paper, approved cardboard, and <strong>approved AR500 steel targets</strong> for centerfire rifle use.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Steel Target Requirements:
                            <List sx={{ listStyleType: 'square', pl: 2, mt: 0.5 }}>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Only use AR500 (or equivalent) rated steel for centerfire rifle impacts.</ListItem>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Steel targets must be <strong>free-hanging or securely mounted</strong> with a downward angle so spall and fragmentation impacts the ground.</ListItem>
                                <ListItem sx={{ display: 'list-item', px: 0, py: 0.125 }}>Maintain recommended distances for the target type and caliber in use.</ListItem>
                            </List>
                        </ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}><strong>Prohibited targets/materials:</strong> No glass bottles, rocks or other materials that could cause a ricochet.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Range Clean-up & Maintenance:</Typography>
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Remove all targets, tape, and trash. Collect all spent brass.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Report any damage, unsafe conditions, or target issues to the Range Committee immediately.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Enforcement & Discipline:</Typography> Unsafe range use/practices will result in privileges being suspended or revoked. Board decisions regarding this are final.
                </ListItem>
            </List>

            <Typography
                variant="h4"
                align="center"
                sx={{
                    mt: 4,
                    fontWeight: 200,
                    fontSize: {
                        xs: '1.5rem',
                        sm: '2rem',
                    }
                }}>
                Certified Forest Use and Hunting Rules
            </Typography>
            <List sx={{ px: { xs: 3, sm: 6 }, listStyleType: 'disc' }}>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Hunting:</Typography> Hunting is only allowed on the north side of the lake and below the dam.
                    <List sx={{ listStyleType: 'circle', pl: 2, mt: 1 }}>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Deer hunting: Bow only, members only.</ListItem>
                        <ListItem sx={{ display: 'list-item', px: 0, py: 0.25 }}>Small game hunting: Members and their accompanied guests.</ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Hunter Check-in:</Typography> Members and guests are to sign into and out of the Check Station at the Shooting Range. Place the "CAUTION" placard on the front of the check station on your way to hunt and remove/reverse to "ALL CLEAR" when you come back. Make sure no other hunters remain in the woods before placing "ALL CLEAR".
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Trail Use:</Typography> Trails are for foot traffic only. Make sure to follow "Leave No Trace" principles. Do not damage trails or vegetation. <strong>Note:</strong> The South Lake Trail is <em>out-and-back only</em>. Do not loop around the lake or towards the back of the Range!
                </ListItem>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>Firewood/Trees:</Typography> Do not cut or remove trees or firewood without Board or Forest Committee approval.
                </ListItem>
            </List>

            <Typography
                variant="h4"
                align="center"
                sx={{
                    mt: 4,
                    fontWeight: 200,
                    fontSize: {
                        xs: '1.5rem',
                        sm: '2rem',
                    }
                }}>
                Suspension Policy
            </Typography>
            <List sx={{ px: { xs: 3, sm: 6 }, listStyleType: 'disc' }}>
                <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
                    The Board of Directors may suspend members for violating club rules or bylaws at their discretion in accordance with <em>Article II, Section 7</em> of the 80 Conservation Club Bylaws, Rev 2026.
                </ListItem>
            </List>

            <Typography
                variant="body2"
                component="div"
                sx={{ px: 3, mt: 4, fontStyle: 'italic', textAlign: 'center' }}
            >
                <strong>Note:</strong> The Executive Board welcomes member feedback on these rules, suggestions for electric site fees, year-round camper storage, or additional clarifications. Contact the Secretary or visit the club website for more information.
            </Typography>

            <Typography
                variant="body2"
                component="div"
                sx={{ px: 3, mt: 2, textAlign: 'center', fontWeight: 600 }}
            >
                80 Conservation Club Rules approved:<br />
                By Executive Board 10/29/2026
            </Typography>
        </Box >
    )
}